import * as Sentry from '@sentry/react';
import { IUser } from '../../interfaces/User.interfaces';

export const setUserScope = (user: IUser) => {
  Sentry.setUser({
    id: user.id,
  });
};

export const clearUserScope = () => {
  Sentry.setUser(null);
};
